import { makeRequestCreator } from './common.js'
import store from '@/store'

const PaymentAPI = {
  /**
   * 결제수단 목록을 가져온다.
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  getPaymentList: (successCallback = () => {}, errorCallback = () => {}) => {
    // 로그인 체크
    makeRequestCreator(
      'getPaymentList',
      {
        method: 'get',
        url: `/payment/list`
      },
      successCallback,
      errorCallback
    )
  },
  payProductsInCart: (
    { price, displayPrice, paymentType, productList },
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    const newProductList = productList.map(product => {
      return {
        productId: product.productId,
        itemCode: product.itemCode,
        price: product.price,
        displayPrice: product.displayPrice,
        purchaseCount: product.purchaseCount,
        couponDetailContractNo: product.couponDetailContractNo,
        couponId: product.couponId,
        billingCode: product.productType,
        sarahProductType: product.type,
        type: product.type
      }
    })

    const data = {
      totalPrice: price,
      totalDisplayPrice: displayPrice,
      paymentType,
      shopSeq: store.getters['main/shopSeq'],
      productList: newProductList
    }

    PaymentAPI.checkPolicyProductsInCart(data, ({ code }) => {
      if (code === 0) {
        makeRequestCreator(
          'payProductsInCart',
          {
            method: 'post',
            url: `/v2/purchase/cart`,
            data: {
              ...data
            }
          },
          successCallback,
          errorCallback
        )
      }
    })
  },
  checkPolicyProductsInCart: (
    { price, displayPrice, productList },
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    const newProductList = productList.map(product => {
      return {
        productId: product.productId,
        itemCode: product.itemCode,
        price: product.price,
        displayPrice: product.displayPrice,
        purchaseCount: product.purchaseCount,
        couponDetailContractNo: product.couponDetailContractNo,
        couponId: product.couponId,
        // 카트 구매 페이지 -> 결제로 넘어올 경우, billingCode로 가공되어있음
        billingCode: product.productType
          ? product.productType
          : product.billingCode,
        sarahProductType: product.type
      }
    })

    makeRequestCreator(
      'checkPolicyProductsInCart',
      {
        method: 'post',
        url: `/v2/purchase/cart/policycheck`,
        data: {
          totalPrice: price,
          totalDisplayPrice: displayPrice,
          shopSeq: store.getters['main/shopSeq'],
          productList: newProductList
        }
      },
      successCallback,
      errorCallback
    )
  },
  payProduct: (
    { product, paymentType, deliveryInfo },
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    const newProduct = {
      og: product.og,
      productId: product.productId,
      shopSeq: store.getters['main/shopSeq'],
      purchaseCount: product.purchaseCount,
      price: product.price,
      displayPrice: product.displayPrice,
      paymentType,
      paymentSystemType: product.paymentSystemType,
      billingCode: product.productType,
      couponId: product.couponId,
      itemCode: product.itemCode,
      couponDetailContractNo: product.couponDetailContractNo,
      sarahProductType: product.type,
      deliveryInfo
    }

    PaymentAPI.checkPolicyProduct(product, ({ code }) => {
      if (code === 0) {
        makeRequestCreator(
          'payProduct',
          {
            method: 'post',
            url: `/v2/purchase/product`,
            data: newProduct
          },
          successCallback,
          errorCallback
        )
      }
    })
  },
  checkGuid: (successCallback = () => {}, errorCallback = () => {}) => {
    makeRequestCreator(
      'checkGuid',
      {
        method: 'get',
        url: `/user/guid/${store.getters['main/shopSeq']}`
      },
      successCallback,
      errorCallback
    )
  },
  checkPolicyProduct: (
    product,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    const newProduct = {
      productId: product.productId,
      shopSeq: product.shopSeq,
      purchaseCount: product.purchaseCount,
      price: product.price,
      displayPrice: product.displayPrice,
      billingCode: product.productType,
      paymentSystemType: product.paymentSystemType,
      couponId: product.couponId,
      itemCode: product.itemCode,
      couponDetailContractNo: product.couponDetailContractNo,
      sarahProductType: product.type
    }

    makeRequestCreator(
      'checkPolicyProduct',
      {
        method: 'post',
        url: `/v2/purchase/product/policycheck`,
        data: {
          ...newProduct
        }
      },
      successCallback,
      errorCallback
    )
  },

  getPaymentResult: (
    token,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getPaymentResult',
      {
        method: 'get',
        url: `v2/purchase/result/${token.toUpperCase()}`
      },
      successCallback,
      errorCallback
    )
  }
}

export default PaymentAPI
